// extracted by mini-css-extract-plugin
export default {"wrapper":"AiPhotoGenerationButtonSave__wrapper--3_RGL","wrapper_none":"AiPhotoGenerationButtonSave__wrapper_none--1JNYv","button":"AiPhotoGenerationButtonSave__button--39S8z"};